import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessManagersService } from '../business-managers.service';
import { AddBusinessManagerGetDataResponse, Business } from '../catalogs.model';
import { CatalogsService } from '../catalogs.service';

@Component({
  selector: 'app-add-business-manager',
  templateUrl: './add-business-manager.component.html',
  styleUrls: ['./add-business-manager.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddBusinessManagerComponent implements OnInit {
  constructor(private catalogsService: CatalogsService, private businessManagersService: BusinessManagersService) {}

  @Input() code: string;
  candidateBusinesses: Business[];
  authorizationId: number;
  selectedBusinessManager: string;
  isQueryOngoing = false;

  ngOnInit(): void {
    this.getBusinessManagersDataFromFacebook();
  }

  getBusinessManagersDataFromFacebook() {
    // From input code, fetch the facebook user managed business managers
    this.isQueryOngoing = true;
    this.businessManagersService.getBusinessManagersDataFromFacebook(this.code).subscribe(
      (response: AddBusinessManagerGetDataResponse) => {
        this.candidateBusinesses = response.businesses;
        this.authorizationId = response.authorization_id;
        this.isQueryOngoing = false;
      },
      () => (this.isQueryOngoing = false)
    );
  }

  connectBusinessManager() {
    // Connect the selected business manager to alcméon
    this.isQueryOngoing = true;
    this.businessManagersService.connectBusinessManager(this.selectedBusinessManager, this.authorizationId).subscribe(
      () => {
        this.isQueryOngoing = false;
        this.catalogsService.goToCatalogs();
      },
      () => (this.isQueryOngoing = false)
    );
  }
}
